import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import TableContext from "context/table/tableContext";
import { FILTER_NAMES, filterBlockStyle, useMediaQueries } from "shared";

import FilterButton from "../components/FilterButton";
import FilterMenu from "../components/FilterMenu";
import FilterDropdown from "../FilterDropdown";
import { useFilters } from "../hooks";

export const FileFilters = () => {
    const { hasNoPermissionToRead } = useContext(TableContext);

    const { t } = useTranslation();
    const { fromSm, toMd, fromLg } = useMediaQueries();
    const { anchorEl, handleOpenMenu, handleCloseMenu } = useFilters();

    return (
        <div css={css(filterBlockStyle)}>
            {(fromSm && toMd) || fromLg ? (
                <FilterDropdown
                    filter={FILTER_NAMES.Type}
                    placeholder={t("Filter##file type")}
                    disabled={hasNoPermissionToRead}
                />
            ) : (
                <>
                    <FilterButton
                        onOpen={handleOpenMenu}
                        isDisabled={hasNoPermissionToRead}
                    >
                        {t("Button##filters")}
                    </FilterButton>

                    <FilterMenu
                        isOpen={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleCloseMenu}
                    >
                        <div>
                            <FilterDropdown
                                filter={FILTER_NAMES.Type}
                                placeholder={t("Filter##file type")}
                            />
                        </div>
                    </FilterMenu>
                </>
            )}
        </div>
    );
};
